import React from "react";
import { Grid } from "@material-ui/core";
import { ButtonSizeOptions } from "@loanbossinc/component-library";

import { Row } from "../styles";
import {
  FieldIconWrapper,
  FieldLeftContentWrapper,
  FieldLevelWrapper,
  FieldNameTypeWrapper,
  FieldNameWrapper,
  FieldRightContentWrapper,
  FieldTypeWrapper,
  FieldWrapper,
  StyledPrimaryButton
} from "../fieldListItemStyles";
import CalcIconBlue from "../../../calcIconBlue.svg";

export const FieldListItemSelector = props => {
  const { deal, field, onClick } = props;

  let fieldTypeLabel = "Unknown";
  if (field.isCalculated) {
    fieldTypeLabel = "Calculated";
  }

  if (field.isFromFile) {
    fieldTypeLabel = "From file";
  }

  if (field.isHardCoded) {
    fieldTypeLabel = "Manual input";
  }

  if (field.isFromLoanBoss) {
    fieldTypeLabel = "Derived by LoanBoss";
  }

  if (field.isFromRentRoll) {
    fieldTypeLabel = "From rent roll";
  }

  let levelLabel = field.level;
  if (levelLabel === "property") {
    levelLabel = "Property";

    if (Boolean(field.propertyId) && Boolean(deal) && Boolean(deal.properties)) {
      const property = deal.properties.find(p => p.id === field.propertyId);
      if (property) {
        levelLabel = property.name;
      }
    }
  } else if (levelLabel === "deal") {
    levelLabel = "Deal-level";
  } else {
    levelLabel = "Universal";
  }

  return (
    <Row>
      <Grid container>
        <FieldWrapper>
          <FieldLeftContentWrapper>
            <FieldIconWrapper>
              <img src={CalcIconBlue} alt="Calc Icon" height={24} width={24} />
            </FieldIconWrapper>
            <FieldNameTypeWrapper>
              <FieldNameWrapper>{field.name}</FieldNameWrapper>
              <FieldTypeWrapper>{fieldTypeLabel}</FieldTypeWrapper>
            </FieldNameTypeWrapper>
          </FieldLeftContentWrapper>
          <FieldRightContentWrapper>
            <FieldLevelWrapper>{levelLabel}</FieldLevelWrapper>
            <StyledPrimaryButton onClick={() => onClick(field.id, field.value)} size={ButtonSizeOptions.sm} label="Select" />
          </FieldRightContentWrapper>
        </FieldWrapper>
      </Grid>
    </Row>
  );
};

export default FieldListItemSelector;
